import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { useDispatch } from 'react-redux';

import PrintDocumentMenuItem from '../../../../components/print-document-menu-item';
import { LABEL } from '../../../../enums/document-type';
import { MessageDescriptorPropType } from '../../../../prop-types/intl';
import { printReturnLabels } from '../../../../store/printing/print.actions';
import { RETURN_ACTION_PRINT_LABEL_CLICKED } from '../../../../constants/analytics-events';
import { Segment } from '../../../../services/analytics-services/segment';

const messages = defineMessages({
  returnLabel: {
    description: 'printDocumentButtonContainers.returnLabel',
    defaultMessage: 'Return Label',
    id: 'uF0TTB',
  },
});

export const ReturnLabel = ({ fulfillmentId, messageDescriptor = messages.returnLabel }) => {
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    Segment.trackEvent(RETURN_ACTION_PRINT_LABEL_CLICKED, {
      type: RETURN_ACTION_PRINT_LABEL_CLICKED,
      enhanced: false,
      fulfillmentId,
    });
    dispatch(printReturnLabels([fulfillmentId]));
  }, [dispatch, fulfillmentId]);

  return (
    <PrintDocumentMenuItem
      docType={LABEL} // EJG: This prop might not be used in the component
      name={messageDescriptor}
      onClick={onClick}
    />
  );
};

ReturnLabel.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
  messageDescriptor: MessageDescriptorPropType,
};
